import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { PortalReportsApi } from '../../../api/portalReports';
import { FaIcon } from '../../FaIcon';

/**
 * Modal para guardar la exploración actual como vista nueva.
 *
 * Solo recolecta nombre + descripción. La asignación al portal del cliente
 * se hace después desde el ShareMenu del Toolbar.
 */
class SaveAsViewModalComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            description: '',
            isSaving: false,
        };
    }

    componentDidUpdate(prevProps) {
        // Reset on open. Si venimos de "Replicar aquí" (Card #2420), pre-cargamos el nombre
        // de la vista origen para que el guardado se sienta como una réplica real.
        if (this.props.isOpen && !prevProps.isOpen) {
            this.setState({
                name: this.props.suggestedName || '',
                description: '',
                isSaving: false,
            });
        }
    }

    handleSave = () => {
        const { t, agencyClientId, config, onSaved, toggle } = this.props;
        const { name, description } = this.state;

        const trimmedName = name.trim();
        if (!trimmedName) {
            toast.error(t('saved_views.name_required'));
            return;
        }
        if (!agencyClientId) {
            toast.error(t('saved_views.client_required'));
            return;
        }
        if (!config) {
            toast.error(t('saved_views.config_required'));
            return;
        }

        this.setState({ isSaving: true });

        PortalReportsApi.createView({
            name: trimmedName,
            description: description.trim() || null,
            agency_client_id: agencyClientId,
            config,
        }).then((response) => {
            // NETWORK_ERROR (fallo de red) no es éxito: no mostrar "guardado" ni cerrar el modal.
            if (!response || response.status === 'ERROR' || response.status === 'NETWORK_ERROR') {
                const msg = (response && response.error_message) || t('saved_views.save_error');
                toast.error(msg);
                this.setState({ isSaving: false });
                return;
            }
            toast.success(t('saved_views.saved'));
            this.setState({ isSaving: false });
            if (onSaved && Array.isArray(response.views) && response.views[0]) {
                onSaved(response.views[0]);
            }
            toggle();
        }).catch(() => {
            toast.error(t('saved_views.save_error'));
            this.setState({ isSaving: false });
        });
    };

    render() {
        const { t, isOpen, toggle } = this.props;
        const { name, description, isSaving } = this.state;
        const canSubmit = name.trim().length > 0 && !isSaving;

        return (
            <Modal isOpen={isOpen} toggle={isSaving ? undefined : toggle}>
                <ModalHeader toggle={isSaving ? undefined : toggle}>
                    {t('saved_views.save_as_title')}
                </ModalHeader>
                <ModalBody>
                    <div className="modal-section">
                        <div className="saved-view-client-note">
                            <FaIcon iconName="eye" className="saved-view-client-note__icon" />
                            <span>{t('saved_views.client_visible_note')}</span>
                        </div>
                        <div className="form-row">
                            <label>{t('saved_views.name_label')}</label>
                            <input
                                type="text"
                                className="form-control"
                                value={name}
                                onChange={(e) => this.setState({ name: e.target.value })}
                                placeholder={t('saved_views.name_placeholder')}
                                autoFocus
                                disabled={isSaving}
                                maxLength={200}
                            />
                        </div>
                        <div className="form-row">
                            <label>{t('saved_views.description_label')}</label>
                            <textarea
                                className="form-control"
                                rows={2}
                                value={description}
                                onChange={(e) => this.setState({ description: e.target.value })}
                                disabled={isSaving}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle} disabled={isSaving}>
                        {t('common.cancel')}
                    </Button>
                    <button className="btn -alt" onClick={this.handleSave} disabled={!canSubmit}>
                        {isSaving ? t('common.saving') : t('saved_views.save')}
                    </button>
                </ModalFooter>
            </Modal>
        );
    }
}

export const SaveAsViewModal = withTranslation()(SaveAsViewModalComponent);
